import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import LotForm from "../../../../commonComponents/LotForm";
import getEventDetailsAPI from "../../../../../api/getEventDetail";
import { createEventItemAPI } from "../../../../../api/createEventItemAPI";
import Loader from "../../../../../common/Loader";
import useStyles from "./item.style";
import routes from "../../../../../constants/routes";
import { saveErrorMessage } from "../../../../../common/saveMessage";
import "react-toastify/dist/ReactToastify.css";

function IndexView({ setHide, hide }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const eventId = location.state?.data?.eventId;
  const [isLoading, setIsLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [options, setOptions] = useState([]);

  const [eventItemInfo, setEventItemInfo] = useState({
    lotNumber: "",
    shortDescription: "",
    longDescription: "",
    quantity: "",
    unit: "",
    startPrice: "",
    startDateAndTime: "",
    increment: "",
    endDateAndTime: "",
    currency: "",
    maxMissedBids: null,
    timeInterval: null,
    minimumAmount: "",
    remarks: "",
    eventItemImages: [],
  });

  const fetchEventDetails = useCallback(async () => {
    try {
      if (!eventId) return;
      setIsLoading(true);
      const { data } = await getEventDetailsAPI({ auctionId: eventId });
      if (data) {
        setEventDetails(data);
        setSelectedCurrency(data.currency || null);
        setEventItemInfo(prev => ({
          ...prev,
          currency: data.currency || ""
        }));
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      toast.error("Couldn't load the event. Please refresh.");
    } finally {
      setIsLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchEventDetails();
  }, [fetchEventDetails]);

  const handleSubmit = async (payload) => {
    try {
      setIsLoading(true);
      const { data } = await createEventItemAPI(payload, eventId);
      if (data) {
        toast.success("Lot created.");
        setTimeout(() => {
          setIsLoading(false);
          setHide(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Error creating event item:", error);
      setIsLoading(false);
      toast.error(saveErrorMessage(error, "Lot not created. Please try again."));
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <LotForm
        mode="create"
        eventItemInfo={eventItemInfo}
        setEventItemInfo={setEventItemInfo}
        eventDetails={eventDetails}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        options={options}
        setOptions={setOptions}
        setIsLoading={setIsLoading}
        onSubmit={handleSubmit}
        classes={classes}
        onCancel={() => setHide(false)}
      >
        <div className={classes.saveNextBtn}>
          <Button
            className={classes.pre}
            onClick={() => setHide(false)}
          >
            Cancel
          </Button>
          <Button
            className={classes.next}
            type="submit"
            sx={{ marginLeft: "1em" }}
          >
            Save
          </Button>
          <Button
            className={classes.next}
            sx={{ marginLeft: "1em" }}
            onClick={() => navigate(routes.dashboard)}
          >
            Go To Dashboard
          </Button>
        </div>
      </LotForm>
    </>
  );
}

export default IndexView;
